import { Image } from '@zoomit/primitives';
import { Flex, Spacing } from '@zoomit/primitives';
import { Typography } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../hooks/useWebKitCustomization';

const SomethingWentWrong = () => {
  const { sthWentWrong } = useWebKitCustomization((x) => x.emptyStatesPublicPath);

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={Spacing.x}
      style={{ width: 'auto' }}
    >
      <Flex flexDirection="column" alignItems="center" gap={Spacing.x2}>
        {sthWentWrong && (
          <Image
            className={'object-contain'}
            width={sthWentWrong.width || 200}
            height={sthWentWrong.height || 200}
            src={sthWentWrong.publicSrc}
            alt="sth went wrong"
          />
        )}
        <Typography tag="p" fontSize={1.4} fontWeight="bold" lineHeight={2}>
          خطایی رخ داده!
        </Typography>
      </Flex>
      <Typography tag="p" fontSize={1.3} lineHeight={1.85}>
        لطفا دوباره سعی کن
      </Typography>
    </Flex>
  );
};

export default SomethingWentWrong;
